<template>
  <div class="ui grid">
    <div class="four wide column">
      <professor-picker @select_professor="select_professor" />      
    </div>
    <div class="twelve wide column">
      <detail ref="detail" :professors="grouped" />
    </div>
  </div>
</template>

<script>
import { groupBy, cloneDeep } from "lodash";
import ProfessorPicker from "./ProfessorPicker";
import Detail from "./Detail";

export default {
  name: "CourseAssignationRevisionTeacherBasedIndex",
  props: { assignation: Object },
  components: { Detail, ProfessorPicker },
  data() {
    return {};
  },
  computed: {
    grouped() {
      let vm = this;
      if (vm.assignation && vm.assignation.crs_assignation_sections) {
        let cloned = cloneDeep(vm.assignation.crs_assignation_sections);
        let grpd = groupBy(cloned, (sect) => {
          return sect.pfs_professor.uuid;
        });
        let grps = Object.keys(grpd).map((k) => {
          let prfs = grpd[k][0].pfs_professor;
          let elmnts = grpd[k].map((el) => {
            delete el.pfs_professor;
            return el;
          });
          return { professor: prfs, sections: elmnts };
        });
        return grps;
      } else {
        return [];
      }
    },
  },
  methods: {
    select_professor(professor) {
      this.$refs.detail.select_professor(professor);
    },
  },
};
</script>
